import "./style.css";

export default class MindMap {
  static selector = ".mind-map";

  constructor(block) {
    this.block = block;

    this.fourthLevelItemsPaddingVertical = 6;
    this.fourthLevelItemsPaddingHorizontal = 14;

    this.plusMargin = 12;

    this.closedMapClass = "map-closed";
    this.enteredMapClass = "map-entered";

    this.titleBar = document.querySelector(".technologies__title-bar");

    this.contentContainer = this.block.parentNode;
  }

  handlePanelOpen = () => {
    this.contentContainer.classList.add(
      "technologies-content--interaction-disabled"
    );
  };

  handlePanelClose = () => {
    this.contentContainer.classList.remove(
      "technologies-content--interaction-disabled"
    );
  };

  handleItemClick = (e) => {
    e.preventDefault();

    const item = e.currentTarget;
    const url = item.dataset.url;

    window.App.navigateTo(url);
  };

  handleFourthLevelMouseEnter = (e) => {
    if (this.svgContainer.classList.contains(this.closedMapClass)) {
      return;
    }
    const item = e.currentTarget;
    this.handleLevelsHighlight(item);
    const textGroup = e.currentTarget.querySelector("g");
    this.handleFourthLevelHighlight(textGroup);
    this.handleAncestorsHighlight(textGroup.parentNode);
  };

  handleFourthLevelMouseLeave = (e) => {
    if (this.svgContainer.classList.contains(this.closedMapClass)) {
      return;
    }
    const item = e.currentTarget;
    this.handleLevelsHighlight(item, true);
    const textGroup = e.currentTarget.querySelector("g");
    this.handleFourthLevelHighlight(textGroup, true);
    this.handleAncestorsHighlight(textGroup.parentNode, true);
  };

  handleItemMouseEnter = (e) => {
    if (
      this.svgContainer.classList.contains(this.closedMapClass) ||
      this.isPanelOpen
    ) {
      return;
    }
    const item = e.currentTarget;
    item.classList.add("highlight");
    this.handleAncestorsHighlight(item);
    // this.handleLevelsHighlight(item);
  };

  handleItemMouseLeave = (e) => {
    if (
      this.svgContainer.classList.contains(this.closedMapClass) ||
      this.isPanelOpen
    ) {
      return;
    }
    const item = e.currentTarget;
    item.classList.remove("highlight");
    this.handleAncestorsHighlight(item, true);
    // this.handleLevelsHighlight(item, true);
  };

  handleFirstLevelMouseEnter = (e) => {
    if (this.svgContainer.classList.contains(this.closedMapClass)) {
      return;
    }
    const item = e.currentTarget;
    this.handleLevelsHighlight(item);
  };

  handleFirstLevelMouseLeave = (e) => {
    if (this.svgContainer.classList.contains(this.closedMapClass)) {
      return;
    }
    const item = e.currentTarget;
    this.handleLevelsHighlight(item, true);
  };

  handleSecondLevelMouseEnter = (e) => {
    if (this.svgContainer.classList.contains(this.closedMapClass)) {
      return;
    }
    const item = e.currentTarget;
    this.handleLevelsHighlight(item);
    const textGroup = e.currentTarget.querySelector("g");
    this.handleAncestorsHighlight(item);
  };

  handleSecondLevelMouseLeave = (e) => {
    if (this.svgContainer.classList.contains(this.closedMapClass)) {
      return;
    }
    const item = e.currentTarget;
    this.handleLevelsHighlight(item, true);
    const textGroup = e.currentTarget.querySelector("g");
    this.handleAncestorsHighlight(item, true);
  };

  handleThirdLevelMouseEnter = (e) => {
    if (this.svgContainer.classList.contains(this.closedMapClass)) {
      return;
    }
    const item = e.currentTarget;
    this.handleLevelsHighlight(item);
    const textGroup = e.currentTarget.querySelector("g");
    this.handleAncestorsHighlight(item);
  };

  handleThirdLevelMouseLeave = (e) => {
    if (this.svgContainer.classList.contains(this.closedMapClass)) {
      return;
    }
    const item = e.currentTarget;
    this.handleLevelsHighlight(item, true);
    const textGroup = e.currentTarget.querySelector("g");
    this.handleAncestorsHighlight(item, true);
  };

  handleAncestorsHighlight = (item, remove = false) => {
    let highlightedItem = item;

    const ancestorsId = JSON.parse(highlightedItem?.dataset.ancestors || "[]");

    for (let index = 1; index < 4; index++) {
      let items;

      switch (index) {
        case 1:
          items = this.thirdLevelItems;
          break;
        case 2:
          items = this.secondLevelItems;
          break;
        case 3:
          items = this.firstLevelItems;
          break;
      }

      const ancestors = Array.from(items).filter((el) =>
        ancestorsId.includes(parseInt(el.dataset.id))
      );

      if (remove) {
        ancestors.forEach((el) => el.classList.remove("highlight"));
      } else {
        ancestors.forEach((el) => el.classList.add("highlight"));
      }
    }
  };

  handleLevelsHighlight = (item, remove = false) => {
    const descendants = item.dataset.descendants
      ? Object.values(JSON.parse(item.dataset.descendants))
      : [];

    if (remove) {
      item.classList.remove("highlight");
    } else {
      item.classList.add("highlight");
    }

    descendants.forEach((child) => {
      this.block
        .querySelectorAll(`.ring-item[data-id='${child}']`)
        .forEach((element) => {
          if (remove) {
            element.classList.remove("highlight");
          } else {
            element.classList.add("highlight");
          }

          // if (element.classList.contains("ring-item--fourth-level")) {
          //   const g = element.querySelector("g");

          //   if (remove) {
          //     this.handleFourthLevelHighlight(g, true);
          //   } else {
          //     this.handleFourthLevelHighlight(g);
          //   }
          // }
        });
    });
  };

  handleFourthLevelHighlight = (textGroup, remove = false) => {
    const text = textGroup.querySelector("text");
    const plusIcon = textGroup.querySelector(".text-plus-icon");
    const rect = textGroup.querySelector("rect");

    if (remove) {
      plusIcon.classList.remove("visible");
      rect.classList.remove("visible");
      text.classList.remove("active");
    } else {
      plusIcon.classList.add("visible");
      rect.classList.add("visible");
      text.classList.add("active");
    }

    if (textGroup.classList.contains("anchor-end")) {
      const g = text.parentNode;
      // these are items that go from 0° to 180°
      if (remove) {
        g.style.transform = `translateX(${this.plusWidth - this.plusMargin}px)`;
      } else {
        g.style.transform = `translateX(-${this.plusWidth}px)`;
      }
    }
  };

  addTextDecoration = () => {
    this.fourthLevelItems.forEach((item) => {
      const textGroup = item.querySelector(".text-group");
      const text = textGroup.querySelector("text");
      const rect = textGroup.querySelector("rect");
      const plus = textGroup.querySelector(".text-plus-icon");

      const textBBox = text.getBBox();
      const { width: textWidth, height: textHeight, x, y } = textBBox;

      const plusBBox = plus.getBBox();
      const { width: plusWidth } = plusBBox;
      this.plusWidth = plusWidth;

      if (textGroup.classList.contains("anchor-start")) {
        // these are items that go from 0° to 180°
        rect.setAttribute("x", x - this.fourthLevelItemsPaddingHorizontal);
      } else {
        rect.setAttribute(
          "x",
          x - this.fourthLevelItemsPaddingHorizontal - this.plusWidth
        );
      }

      rect.setAttribute("y", y - this.fourthLevelItemsPaddingVertical);
      rect.setAttribute(
        "width",
        textWidth + this.fourthLevelItemsPaddingHorizontal * 2 + this.plusWidth
      );
      rect.setAttribute(
        "height",
        textHeight + this.fourthLevelItemsPaddingVertical * 2
      );
      rect.setAttribute(
        "rx",
        (textHeight + this.fourthLevelItemsPaddingVertical * 2) * 0.5
      );

      if (textGroup.classList.contains("anchor-start")) {
        // these are items that go from 0° to 180°
        plus.style.transform = `translateX(${textWidth + this.plusMargin}px)`;
      }

      // align plus symbol to the center of the text
      // needed for multiline titles and (firefox only) for single line titles
      plus.style.transform += `translateY(${y + textHeight / 2}px)`;
    });
  };

  addListeners = () => {
    // this.ringItems.forEach((item) => {
    //   item.addEventListener("mouseenter", this.handleItemMouseEnter);
    //   item.addEventListener("mouseleave", this.handleItemMouseLeave);
    // });

    this.firstLevelItems.forEach((item) => {
      item.addEventListener("mouseenter", this.handleFirstLevelMouseEnter);
      item.addEventListener("mouseleave", this.handleFirstLevelMouseLeave);
    });

    this.secondLevelItems.forEach((item) => {
      item.addEventListener("mouseenter", this.handleSecondLevelMouseEnter);
      item.addEventListener("mouseleave", this.handleThirdLevelMouseLeave);
    });

    this.thirdLevelItems.forEach((item) => {
      item.addEventListener("mouseenter", this.handleThirdLevelMouseEnter);
      item.addEventListener("mouseleave", this.handleSecondLevelMouseLeave);
    });

    this.fourthLevelItems.forEach((item) => {
      item.addEventListener("mouseenter", this.handleFourthLevelMouseEnter);
      item.addEventListener("mouseleave", this.handleFourthLevelMouseLeave);
      item.addEventListener("click", this.handleItemClick);
    });

    this.block.addEventListener("panelopen", this.handlePanelOpen);

    this.block.addEventListener("panelclose", this.handlePanelClose);

    this.svgContainer.addEventListener(
      "transitionend",
      this.handleWheelContainerTransition
    );
  };

  sizeWheel = () => {
    const wh = window.innerHeight;
    const ww = window.innerWidth;
    const elementSize = Math.min(wh, ww);

    if (ww < wh) {
      this.svgContainer.style.width = `${ww + 100}px`;
      this.svgContainer.style.height = `100%`;
    } else {
      this.svgContainer.style.width = `100%`;
      this.svgContainer.style.height = `${elementSize}px`;
    }

    this.svgContainer.classList.remove("hidden");
  };

  enterWheel = () => {
    this.svgContainer.classList.add(this.enteredMapClass);
  };

  exitWheel = () => {
    this.svgContainer.classList.remove(this.enteredMapClass);
  };

  closeWheel = () => {
    this.svgContainer.classList.add(this.closedMapClass);
  };

  handleWheelContainerTransition = (e) => {
    if (
      e.propertyName === "opacity" &&
      this.svgContainer.classList.contains(this.closedMapClass)
    ) {
      this.svgContainer.classList.remove(this.enteredMapClass);
      this.titleBar.classList.remove("technologies__title-bar--hidden");
    }
  };

  onReady() {
    this.svgElement = this.block.querySelector("svg");
    this.mapSvg = this.svgElement.querySelector("svg g");
    this.ringItems = this.mapSvg.querySelectorAll(".ring-item");
    this.svgContainer = this.block.querySelector(".mind-map__wheel-container");

    this.sizeWheel();

    this.firstLevelItems = this.mapSvg.querySelectorAll(
      ".ring-item--first-level"
    );

    this.secondLevelItems = this.mapSvg.querySelectorAll(
      ".ring-item--second-level"
    );

    this.thirdLevelItems = this.mapSvg.querySelectorAll(
      ".ring-item--third-level"
    );

    this.fourthLevelItems = this.mapSvg.querySelectorAll(
      ".ring-item--fourth-level"
    );

    this.addTextDecoration();
    this.addListeners();
  }

  onResize() {
    this.sizeWheel();
  }

  onDestroy() {
    // this.ringItems.forEach((item) => {
    //   item.removeEventListener("mouseenter", this.handleItemMouseEnter);
    //   item.removeEventListener("mouseleave", this.handleItemMouseLeave);
    // });

    this.firstLevelItems.forEach((item) => {
      item.removeEventListener("mouseenter", this.handleFirstLevelMouseEnter);
      item.removeEventListener("mouseleave", this.handleFirstLevelMouseLeave);
    });

    this.secondLevelItems.forEach((item) => {
      item.removeEventListener("mouseenter", this.handleSecondLevelMouseEnter);
      item.removeEventListener("mouseleave", this.handleThirdLevelMouseLeave);
    });

    this.thirdLevelItems.forEach((item) => {
      item.removeEventListener("mouseenter", this.handleThirdLevelMouseEnter);
      item.removeEventListener("mouseleave", this.handleSecondLevelMouseLeave);
    });

    this.fourthLevelItems.forEach((item) => {
      item.removeEventListener("mouseenter", this.handleFourthLevelMouseEnter);
      item.removeEventListener("mouseleave", this.handleFourthLevelMouseLeave);
      item.removeEventListener("click", this.handleItemClick);
    });

    this.block.removeEventListener("panelopen", this.handlePanelOpen);

    this.block.removeEventListener("panelclose", this.handlePanelClose);
  }
}
